import React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import useStyles from "./HRKRIReportingAnalytics.styles";
import { HedgeRatioProvider } from "../../../context/HedgeRatioContext";
import WhatWeDo from "../../whatWeDo/WhatWeDo.component";
import HRKRIFiltersAndReports from "./HRKRIFiltersAndReports.component";
import { ApprovalProvider } from "../../../context/ApprovalContext";
import { EmailProvider } from "../../../context/EmailContext";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const HRKRIReportingAnalytics = ({ toCompare = false } = {}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.page}>
      <Grid container item spacing={2}>
        <HedgeRatioProvider>
          <ApprovalProvider>
            <EmailProvider>
              <HRKRIFiltersAndReports toCompare={toCompare} />
            </EmailProvider>
          </ApprovalProvider>
        </HedgeRatioProvider>
        {toCompare && (
          <HedgeRatioProvider>
            <ApprovalProvider>
              <EmailProvider>
                <HRKRIFiltersAndReports toCompare={toCompare} />
              </EmailProvider>
            </ApprovalProvider>
          </HedgeRatioProvider>
        )}
        <Grid size={{ xs: 12, md: 12 }} sx={{ display: "none" }}>
          <Item>
            <WhatWeDo />
          </Item>
        </Grid>
      </Grid>
    </div>
  );
};

export default HRKRIReportingAnalytics;
